export default __webpack_public_path__ + "static/media/usersubs.397e6008.svg";